import React, { useState, useEffect } from 'react';
import { Layout, Menu, Spin, notification } from 'antd';
import { 
  TeamOutlined, 
  AppstoreOutlined, 
  UploadOutlined 
} from '@ant-design/icons';
import ErrorBoundary from './components/ErrorBoundary';
import AuthModal from './components/AuthModal';
import AgainstShow from './pages/AgainstShow';
//import Notification from './components/Notification';
import UserManagement from './pages/UserManagement';
import ClubManagement from './pages/ClubManagement';
import UploadManagement from './pages/UploadManagement';
import api from './services/api';
import './styles/animations.css';
import './styles/main.css';

const { Header, Content, Sider, Footer } = Layout;

const App = () => {
  const [_api, contextHolder] = notification.useNotification();
  const [activeMenu, setActiveMenu] = useState('upload');
  const [authModalVisible, setAuthModalVisible] = useState(false);
  const [card, setCard] = useState('');
  const [loading, setLoading] = useState(false);

  const setNotification=(config)=>{
    config.description = config.message;
    config.message = config.type;
      _api.open(config);
  }
  
  // 检查卡密
  useEffect(() => {
    const savedCard = localStorage.getItem('card');
    if (savedCard) {
      setCard(savedCard);
      verifyCard(savedCard);
    } else {
      setAuthModalVisible(true);
    }
  }, []);

  // 验证卡密有效性
  const verifyCard = async (cardValue) => {
    try {
      setLoading(true);
      const res = await api.post('/api/testCard', { card: cardValue, type:"change" });
      if (res.status === 200) {
        localStorage.setItem('card', cardValue);
        setCard(cardValue);
        setNotification({
          type: 'success',
          message: '卡密验证成功'
        });
        setAuthModalVisible(false);
      }
    } catch (e) {
      setNotification({
        type: 'error',
        message: e.response?.data?.message || '卡密验证失败'
      });
      localStorage.removeItem('card');
      setAuthModalVisible(true);
    } finally {
      setLoading(false);
    }
  };

  const handleCardSubmit = (cardValue) => {
    verifyCard(cardValue);
  };
  return (
    <>{contextHolder}
    <ErrorBoundary>
      <Layout style={{ minHeight: '100vh' }} >
        <Sider collapsible>
          <div className="logo"></div>
          <Menu 
            theme="dark" 
            mode="inline"
            selectedKeys={[activeMenu]}
            onSelect={({ key }) => setActiveMenu(key)}
          >
            <Menu.Item key="upload" icon={<UploadOutlined />}>
              上传管理
            </Menu.Item>
            <Menu.Item key="user" icon={<TeamOutlined />}>
              用户管理
            </Menu.Item>
            <Menu.Item key="club" icon={<AppstoreOutlined />}>
              社团管理
            </Menu.Item>
            {false && <Menu.Item key="against" icon={<AppstoreOutlined />}>
              赛程图
            </Menu.Item>}
          </Menu>
        </Sider>
        <Layout className="site-layout">
          <Header className="site-layout-header">
            <h1>TanYU 后台管理系统</h1>
          </Header>
          
          <Content style={{ margin: '16px' }}>
            <div className="site-layout-background" style={{ padding: 24, minHeight: 360 }}>
              {loading ? (
                <div className="loading-container">
                  <Spin size="large" />
                </div>
              ) : (
                <>
                  {activeMenu === 'upload' && <UploadManagement card={card} />}
                  {activeMenu === 'user' && <UserManagement card={card} />}
                  {activeMenu === 'club' && <ClubManagement card={card} />}
                  {activeMenu === 'against' && <AgainstShow card={card} />}
                </>
              )}
            </div>
          </Content>
        </Layout>
      </Layout>
      
      <AuthModal
        visible={authModalVisible}
        onOk={handleCardSubmit}
        onCancel={() => setNotification({"type":"error","message":"请输入卡密，成功后将自动退出"})}
      />
    </ErrorBoundary>
    </>
  );
};
export default App;